/* eslint-disable react/prop-types */
import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch(_error, _info) {
    this.setState({ hasError: true })
  }

  render() {
    const {
      state: { hasError },
      props: { children }
    } = this
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <>
          <h1>Something went wrong</h1>
        </>
      )
    }
    return children
  }
}

export default ErrorBoundary
